import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {FormSection} from '@pb/kit-component-form-section';
import {Group, Item} from '@pb/kit-component-group';


export const BrowserRegistrationSkeleton = () => (
    <FormSection
        headline="Browser Registration"
        info={() => (
            <Item grow={1}>
                <Group justify="space-between">
                    <SkeletonItem width={170} height={28}/>
                    <SkeletonItem width={100} height={28}/>
                </Group>
            </Item>
        )}>
        <Group direction="v">
            <Group gap="s">
                <SkeletonItem width={300} height={16}/>
            </Group>
            <Group direction="v" gap="s">
                <Group gap="s">
                    <SkeletonItem width={60} height={12}/>
                    <SkeletonItem width={100} height={12}/>
                    <SkeletonItem width={100} height={12}/>
                    <SkeletonItem width={100} height={12}/>
                </Group>
                {[...new Array(5)].map((data, index) => (
                    <Group key={index} gap="s">
                        <SkeletonItem width={60} height={12}/>
                        <SkeletonItem width={100} height={12}/>
                        <SkeletonItem width={100} height={12}/>
                        <SkeletonItem width={100} height={12}/>
                    </Group>
                ))}
            </Group>
        </Group>
    </FormSection>
);
